import script from "./SettingsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsView.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsView.vue?vue&type=style&index=0&id=3dd8f508&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dd8f508"]])

export default __exports__